export default __webpack_public_path__ + "static/media/i239hk.9cbdfe90.webp";